<template>
    <div>
        <div class="top clearfix">
            <div class="topMessage">品名:{{data.inventory.breed}}</div>
            <div class="topMessage">捆包号:{{data.inventory.bale_no}}</div>
            <div class="topMessage">等级:{{data.inventory.grade}}</div>
            <div class="topMessage">厚度:{{data.inventory.original_thickness}}</div>
            <div class="topMessage">长度:{{data.inventory.original_length}}</div>
        </div>
        <div class="box">
            <div class="addTable">
                <div class="tableThBox">
                    <div class="tableTh tableThC tableThLT">长度</div>
                    <div class="tableTh tableThC tableThLT">厚度</div>
                    <div class="tableTh tableThIndex" v-for="index of 23" :key="index">{{index+2}}</div>
                    <div class="tableTh tableThC">PCS</div>
                    <div class="tableTh tableThC">BF</div>
                    <div class="tableTh tableThC">M3</div>
                </div>
                <div class="tableTdBox">
                    <div class="tableTh tableThC tableThLT">
                        <input class="tableInput tableInputEnter" index="0" @change="calDataFunc" :style="calDataCopy['length']?calDataCopy['length']!=calData['length']?'color:red;':'':''" v-model="calData.length"/>
                    </div>
                    <div class="tableTh tableThC tableThLT">
                        <input class="tableInput tableInputEnter" index="1" @change="calDataFunc" :style="calDataCopy['thickness']?calDataCopy['thickness']!=calData['thickness']?'color:red;':'':''" v-model="calData.thickness"/>
                    </div>
                    <div class="tableTh tableThIndex" v-for="index of 23" :key="index">
                        <input class="tableInput tableInputEnter" :index="index+1" @change="calDataFunc" :style="calDataCopy['width'+(index+2)]?calDataCopy['width'+(index+2)]!=calData['width'+(index+2)]?'color:red;':'':''" v-model="calData['width'+(index+2)]"/>
                    </div>
                    <div class="tableTh tableThC">
                        <input class="tableInput" readonly v-model="calData.pcs"/>
                    </div>
                    <div class="tableTh tableThC">
                        <input class="tableInput" readonly v-model="calData.bf"/>
                    </div>
                    <div class="tableTh tableThC">
                        <input class="tableInput" readonly v-model="calData.cube"/>
                    </div>
                </div>
            </div>
            <div class="custom">
                <div class="customBtn" @click="calData.scale = 1.01;calDataFunc()">1.01</div>
                <div class="customBtn" @click="calData.scale = 1.02;calDataFunc()">1.02</div>
                <div class="customBtn" @click="calData.scale = 1.03;calDataFunc()">1.03</div>
                <div class="customBtn" @click="calData.scale = 1.04;calDataFunc()">1.04</div>
                <div class="customInputBox clearfix">
                    <div class="customInputTitle">自定义：</div>
                    <input class="customInput" v-model="calData.scale" @change="calDataFunc"/>
                </div>
                <div class="customInputBox clearfix">
                    <div class="customInputTitle">微调：</div>
                    <el-checkbox v-model="calData.manual" @change="res=>{this.calData.manual = res;}"></el-checkbox>
                    <!-- <input class="customInput" v-model="calData.manual" @change="calDataFunc"/> -->
                </div>
                <div class="customBtnSave" @click="saveCal">确认保存</div>
                <div class="customBtnReset" @click="reset">重置</div>
            </div>
            <div class="originalBox">
                <div class="original">
                    <div class="originalTitle">
                        <span class="originalTitleSpan">原码单总板尺 : {{data.up.total.bf}}</span>
                        <span class="originalTitleSpan">总方数 : {{data.up.total.cube}}</span>
                    </div>
                    <div class="seeTable">
                        <el-table :data="data.up.list" border stripe size="mini" height="100%" @row-click="toggleSelection">
                            <el-table-column type="index" label="序号" align="center" width="40"></el-table-column>
                            <el-table-column label="操作" align="center" width="38">
                                <template slot-scope="scope">
                                    <i class="operation_delete" @click.stop="del(scope.row.id)" title="删除"></i>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column label="ID" align="center" width="50" prop="inventory_id" show-overflow-tooltip></el-table-column> -->
                            <el-table-column label="长度" align="center" width="40" prop="length" show-overflow-tooltip></el-table-column>
                            <el-table-column label="厚度" align="center" width="40" prop="thickness" show-overflow-tooltip></el-table-column>
                            <el-table-column :label="(index+2)+''" v-for="index of 23" :key="index" align="center" width="34" :prop="'width'+(index+2)" show-overflow-tooltip></el-table-column>
                            <el-table-column label="PCS" align="center" width="72" prop="pcs" show-overflow-tooltip></el-table-column>
                            <el-table-column label="BF" align="center" width="72" prop="bf" show-overflow-tooltip></el-table-column>
                            <el-table-column label="M3" align="center" width="72" prop="cube" show-overflow-tooltip></el-table-column>
                        </el-table>
                        <!-- <div class="tableThBox">
                            <div class="tableTh tableThC">序号</div>
                            <div class="tableTh tableThC">操作</div>
                            <div class="tableTh tableThC">ID</div>
                            <div class="tableTh tableThC">长度</div>
                            <div class="tableTh tableThC">厚度</div>
                            <div class="tableTh tableThIndex" v-for="index of 23" :key="index">{{index+2}}</div>
                            <div class="tableTh tableThC">PCS</div>
                            <div class="tableTh tableThC">BF</div>
                            <div class="tableTh tableThC">M3</div>
                        </div>
                        <div class="tableThBox tableTdBox" v-for="(item,list) in data.up.list" :key="list">
                            <div class="tableTh tableThC">{{list+1}}</div>
                            <div class="tableTh tableThC">操作</div>
                            <div class="tableTh tableThC">{{item.inventory_id}}</div>
                            <div class="tableTh tableThC">{{item.length}}</div>
                            <div class="tableTh tableThC">{{item.thickness}}</div>
                            <div class="tableTh tableThIndex" v-for="index of 23" :key="index">{{item['width'+(index+2)]}}</div>
                            <div class="tableTh tableThC">{{item.pcs}}</div>
                            <div class="tableTh tableThC">{{item.bf}}</div>
                            <div class="tableTh tableThC">{{item.cube}}</div>
                        </div> -->
                    </div>
                </div>
                <div class="original">
                    <div class="originalTitle">
                        新码单总板尺 : <span class="originalTitleSpan">{{data.down.total.bf}}</span>
                        总方数 : <span class="originalTitleSpan">{{data.down.total.cube}}</span>
                        <span class="originalTitleSpan">{{data.up_side}}</span></div>
                    <div class="seeTable">
                        <el-table :data="data.down.list" border stripe size="mini" height="100%">
                            <el-table-column type="index" label="序号" align="center" width="40"></el-table-column>
                            <el-table-column label="操作" align="center" width="38">
                                <template slot-scope="scope">
                                    <i class="operation_delete" @click.stop="del(scope.row.id)" title="删除"></i>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column label="ID" align="center" width="50" prop="inventory_id" show-overflow-tooltip></el-table-column> -->
                            <el-table-column label="长度" align="center" width="40" prop="length" show-overflow-tooltip></el-table-column>
                            <el-table-column label="厚度" align="center" width="40" prop="thickness" show-overflow-tooltip></el-table-column>
                            <el-table-column :label="(index+2)+''" v-for="index of 23" :key="index" align="center" width="34" :prop="'width'+(index+2)" show-overflow-tooltip></el-table-column>
                            <el-table-column label="PCS" align="center" width="72" prop="pcs" show-overflow-tooltip></el-table-column>
                            <el-table-column label="BF" align="center" width="72" prop="bf" show-overflow-tooltip></el-table-column>
                            <el-table-column label="M3" align="center" width="72" prop="cube" show-overflow-tooltip></el-table-column>
                        </el-table>
                        <!-- <div class="tableThBox">
                            <div class="tableTh tableThC">序号</div>
                            <div class="tableTh tableThC">操作</div>
                            <div class="tableTh tableThC">ID</div>
                            <div class="tableTh tableThC">长度</div>
                            <div class="tableTh tableThC">厚度</div>
                            <div class="tableTh tableThIndex" v-for="index of 23" :key="index">{{index+2}}</div>
                            <div class="tableTh tableThC">PCS</div>
                            <div class="tableTh tableThC">BF</div>
                            <div class="tableTh tableThC">M3</div>
                        </div>
                        <div class="tableThBox tableTdBox" v-for="(item,list) in data.down.list" :key="list" @click="gotoEdit(item)">
                            <div class="tableTh tableThC">{{list+1}}</div>
                            <div class="tableTh tableThC">操作</div>
                            <div class="tableTh tableThC">{{item.inventory_id}}</div>
                            <div class="tableTh tableThC">{{item.length}}</div>
                            <div class="tableTh tableThC">{{item.thickness}}</div>
                            <div class="tableTh tableThIndex" v-for="index of 23" :key="index">{{item['width'+(index+2)]}}</div>
                            <div class="tableTh tableThC">{{item.pcs}}</div>
                            <div class="tableTh tableThC">{{item.bf}}</div>
                            <div class="tableTh tableThC">{{item.cube}}</div>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:["stockid"],
    data(){
        return{
            id:"",
            data:{
                inventory:{
                    breed:"",
                    bale_no: "",
                    grade: "",
                    original_cube: "",
                    original_length: "",
                    original_thickness: "",
                    plate_ruler: ""
                },
                down:{
                    list:[],
                    total:0
                },
                up:{
                    list:[],
                    total:0
                },
                up_side:""
            },
            calData:{
                id:"",
                parent_id:"",
                inventory_id:"",
                length:"",
                thickness:"",
                width3:"",
                width4:"",
                width5:"",
                width6:"",
                width7:"",
                width8:"",
                width9:"",
                width10:"",
                width11:"",
                width12:"",
                width13:"",
                width14:"",
                width15:"",
                width16:"",
                width17:"",
                width18:"",
                width19:"",
                width20:"",
                width21:"",
                width22:"",
                width23:"",
                width24:"",
                width25:"",
                pcs:"",
                bf:"",
                cube:"",
                scale:"",
                manual:false
            },
            calDataCopy:{}
        }
    },
    mounted(){
        let _this = this;
        //回车事件
        document.onkeydown = function (event) {
            var e = event || window.event;
            if (e && e.keyCode == 13) { 
                _this.moveCursor(event,1)
            }else if(e && e.keyCode == 37){
                _this.moveCursor(event,-1)
            }else if(e && e.keyCode == 39){
                _this.moveCursor(event,1)
            }
        }
    },
    methods:{
        moveCursor(event,value){
            var obj = window.event.srcElement; 
            let flag = value>0?document.getElementsByClassName("tableInputEnter").length-1>parseInt(obj.getAttribute("index")):parseInt(obj.getAttribute("index"))>0;
            if(flag){
                document.getElementsByClassName("tableInputEnter")[parseInt(obj.getAttribute("index"))+value].focus()
            }
        },
        del(id){
            this.$confirm('是否确定删除', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.postFuncLoading("/erp/inventory.sheet.delete",{id:id},res=>{
                    this.tip("删除成功","success")
                    this.$emit("getList")
                    this.getDetail()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }).catch(()=>{});
        },
        reset(){
            this.calData = this.resetJson(this.calData);
            this.calData.manual = false;
            this.calDataCopy = this.resetJson(this.calDataCopy);
        },
        toggleSelection(row){
            let rowC = JSON.parse(JSON.stringify(row));
            rowC.manual = false;
            this.calData = JSON.parse(JSON.stringify(rowC));
            this.calDataCopy = JSON.parse(JSON.stringify(rowC));
        },
        saveCal(){
            this.postFuncLoading("/erp/inventory.sheet.save",this.calData,res=>{
                this.tip("添加成功","success")
                this.$emit("getList")
                this.reset();
                this.getDetail()
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        calDataFunc(){
            this.calData.inventory_id = this.id;
            if(this.calData.length!=""&&this.calData.thickness!=""){
                this.postFunc("/erp/inventory.sheet.calc",this.calData,res=>{
                    // this.calData.pcs = res.data.data.pcs;
                    // this.calData.bf = res.data.data.bf;
                    // this.calData.m3 = res.data.data.m3;
                    this.calData = res.data.data;
                    // this.$emit("getList")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            }
        },
        getDetail(){
            this.postFuncLoading("/erp/inventory.sheet.list",{inventory_id:this.id},res=>{
                this.data = res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        }
    },
    watch:{
        "stockid":{
            immediate:true,
            handler:function(val){
                this.id = val;
                if(this.id){
                    this.getDetail()
                }else{
                    this.reset()
                }
            }
        }
    }
}
</script>
<style scoped>
    .top{text-align: center;padding:10px 0;border-bottom:1px solid #e4e4e4;}
    .topMessage{display: inline-block;position: relative;font-size: 13px;margin-right:15px;color:#000;}
    .topMessage::before{content:"";width:1px;height:90%;background-color: #b21111;position: absolute;top:2px;left:-5px;}
    .box{padding:10px 20px;}
    .addTable{border-top:1px solid;border-right:1px solid;border-color:#ccc;}
    .tableThBox{display: flex;}
    .tableTh{font-size: 13px;color:#000;background-color: #EBEDF3;padding:8px 0;border:1px solid #ccc;border-top:0;border-right:0;}
    .tableThC{flex-basis: 80px;}
    .tableThIndex{flex: 1;text-align: center;}
    .tableThLT{flex-basis: 60px;}
    .tableTdBox{display: flex;}
    .tableInput{width:100%;border:0;outline: none;padding:0 3px;font-size: 12px;text-align: center;}
    .tableTdBox .tableTh{background: none;}
    .custom{padding:10px 0;text-align: center;}
    .customBtn{display: inline-block;font-size: 12px;padding:5px 15px;border-radius: 3px;background-color: #db5454;color:#fff;margin-right:10px;cursor: pointer;}
    .customInputBox{display: inline-block;margin-right:10px;}
    .customInputTitle{display: inline-block;font-size: 14px;}
    .customInput{display: inline-block;width:70px;border:1px solid #b21111;border-radius: 3px;outline: none;height:25px;line-height: 25px;padding:0 5px;box-sizing: border-box;}
    .customBtnSave{display: inline-block;font-size: 12px;padding:5px 15px;border-radius: 3px;background-color: #b21111;color:#fff;margin-right:10px;cursor: pointer;}
    .customBtnReset{display: inline-block;font-size: 12px;padding:5px 15px;border-radius: 3px;background-color: #6d757d;color:#fff;margin-right:10px;cursor: pointer;}
    .originalTitle{font-size: 15px;text-align: left;padding:10px 0;color:#000;}
    .seeTable{border-top:1px solid;border-right:1px solid;border-color:#ccc;}
    .seeTable .tableThC{flex-basis:45px;}
    .seeTable .tableTdBox .tableThC{background: none;}
    .seeTable >>> .cell{padding:0 5px;}
    .originalTitleSpan{margin-right:20px;}
    .original >>> .el-table__body-wrapper{min-height: 110px;}
    .originalBox{height:400px;overflow: auto;}
    
    .box >>> .el-table .cell.el-tooltip{min-width: unset;}
    .box >>> .el-table--scrollable-y .el-table__body-wrapper{height:auto !important;}
</style>